














































































































































































































































































import Component from 'vue-class-component'
import UnifyButton from '@/shared/components/unify/unify-button.vue'
import UnifyPage from '@/shared/components/unify/unify-page.vue'
import RespondecoPortfolioItem from '@/shared/components/respondeco-portfolio-item.vue'
import UnifyHero from '@/shared/components/unify/unify-hero.vue'
import { Injector } from '@/config/dependency-injection'
import RespondecoLoadingIndicator from '@/shared/components/respondeco-loading-indicator.vue'
import { BaseComponent } from '@/shared/components/base-component'
import { Hooks } from '@/shared/interfaces/hooks'
import { HomeService } from '@/business/home/home-service'
import UnifyPageContent from '@/shared/components/unify/unify-page-content.vue'
import KonstanzOffer from '@/business/home/components/konstanz-offer.vue'
import { KonstanzHomeState } from '@/business/home/store/konstanz-home-state'
import RespondecoIcon from '@/shared/components/respondeco-icon.vue'

@Component({
  name: 'Konstanz',
  components: {
    RespondecoIcon,
    KonstanzOffer,
    UnifyPageContent,
    RespondecoLoadingIndicator,
    UnifyHero,
    RespondecoPortfolioItem,
    UnifyPage,
    UnifyButton,
  },
})
export default class Konstanz extends BaseComponent implements Hooks {
  public homeState: KonstanzHomeState | null = null
  public loading: boolean = true

  private homeService = Injector.get(HomeService)

  get hasCurrentOffers(): boolean {
    return (this.homeState?.currentOffers.length ?? 0) > 0
  }

  mounted(): void {
    this.homeService.konstanz$.get().then(response => {
      this.homeState = response
      this.loading = false
    })

    this.metaService.updateDocumentTitle('konstanz')
  }
}
